<template>
	<tr class="u-txt-sm">
		<td class="table-section u-flex u-flex--column u-padd-sides">
			<strong v-html="item.name"></strong>
		</td>
		<td class="table-section u-txt-xs u-txt-center u-padd-sides">
			<span v-html="item.part"></span>
		</td>
		<td class="table-section product-download-link u-txt-center u-padd-sides">
			<span v-html="item.size"></span>
		</td>
	</tr>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
		},
	},
	data() {
		return {
			extension: null,
		};
	},
	mounted() {
		if (this.$props.item.extension) {
			this.$props.item.extension = this.$props.item.extension.toUpperCase();
		}
		if (this.$props.item.fileSize) {
			var i = Math.floor(Math.log(this.$props.item.fileSize) / Math.log(1024));
			this.$props.item.fileSize =
				(this.$props.item.fileSize / Math.pow(1024, i)).toFixed(2) * 1 +
				" " +
				["B", "kB", "MB", "GB", "TB"][i];
		} else {
			this.$props.item.fileSize = "0 KB";
		}
	},
	methods: {},
};
</script>
